import { render } from "./DateQuerySetter.vue?vue&type=template&id=383fbe50"
import script from "./DateQuerySetter.vue?vue&type=script&lang=js"
export * from "./DateQuerySetter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__